<template>
  <div class="inner" id="product-wrapper">
    <div class="store-info-wrap" :id="`scrollable/shop`">
      <section class="section border-bottom">
        <div class="top-store-info">
          <div class="state">
            <ul class="tag-wrap">
              <li class="online-card yd-badge yd-badge--payment-online" v-if="storeInfo.isViaOnlinePayment">
                {{ t('store.info.payment_methods.online_abbr') }}
              </li>
              <li class="cash yd-badge yd-badge--payment-cash" v-if="storeInfo.isViaCash">
                {{ t('store.info.payment_methods.cash_abbr') }}
              </li>
              <li class="card yd-badge yd-badge--payment-card" v-if="storeInfo.isViaCard">
                {{ t('store.info.payment_methods.credit_card_abbr') }}
              </li>
              <li class="bank yd-badge yd-badge--payment-bank" v-if="storeInfo.isViaAutomaticWithdrawal">
                {{ t('store.info.payment_methods.send_abbr') }}
              </li>
            </ul>
            <div class="likes">
              <button class="heart" :class="{ active: isFavStore }" @click="like"></button>
            </div>
          </div>
          <div class="store-info-detail-wrap">
            <ul>
              <li>
                <!--        최소주문금액          -->
                <p class="title">{{ $t('store.info.required_pay_amount') }}</p>
                <p class="gray90">{{ toVn(storeInfo?.minimumPriceForDelivery) }}</p>
              </li>
              <li>
                <!--            예상 배달시간-->
                <p class="title">{{ $t('store.info.estimated_delivery_time') }}</p>
                <p class="gray90">
                  {{
                    `${storeInfo?.minimumDeliveryDuration ?? 0}${$t('store.info.minute')}~${
                      storeInfo?.maximumDeliveryDuration ?? 0
                    }${$t('store.info.minute')}`
                  }}
                </p>
              </li>
              <li>
                <p class="title">{{ $t('store.info.delivery_km') }}</p>
                <p class="gray90">
                  {{
                    Util.getDistance(
                      userPosition.latitude,
                      userPosition.longitude,
                      storeInfo?.latitude,
                      storeInfo?.longitude
                    ).toFixed(1)
                  }}km
                </p>
              </li>
            </ul>
            <div class="content">
              <div class="review-wrap">
                <div class="review">
                  <i :class="item" v-for="(item, index) in calcStar(star)" :key="`star_${index}`"></i> {{ star }}
                  <span>({{ (storeInfo?.totalReviewCount ?? 0) + (storeInfo?.totalReplCount ?? 0) }})</span>
                </div>
              </div>
              <div class="btn-wrap">
                <button class="btn bo-gray" @click="call"><i class="i_call"></i></button>
                <button class="btn bo-gray" @click="chat"><i class="i_message"></i></button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        v-if="hasStoreNotice"
        ref="noticeSection"
        class="section border-bottom store-main-notice"
        :class="{ 'store-main-notice--collapsed': !isNoticeExpanded }"
        :aria-label="noticeSectionLabel"
      >
        <div class="store-main-notice__inner">
          <img
            v-if="!isNoticeExpanded"
            src="@/assets/static/images/megaphone_notice_lively_tilted.svg"
            class="store-main-notice__icon"
            alt=""
            aria-hidden="true"
          />
          <div
            v-if="isNoticeExpanded"
            id="store-main-notice-content"
            class="editor store-main-notice__content"
            v-html="storeNotice"
          ></div>
          <div
            v-else
            id="store-main-notice-content"
            ref="noticeContent"
            class="editor store-main-notice__content store-main-notice__content--collapsed"
            v-text="collapsedNoticeText"
          ></div>
          <button
            v-if="shouldShowNoticeToggle"
            type="button"
            class="store-main-notice__toggle"
            aria-controls="store-main-notice-content"
            :aria-expanded="isNoticeExpanded"
            :aria-label="isNoticeExpanded ? undefined : noticeToggleLabel"
            @click="toggleNotice"
          >
            <span v-if="isNoticeExpanded">{{ noticeToggleLabel }}</span>
            <span
              class="store-main-notice__toggle-chevron"
              :class="{ 'store-main-notice__toggle-chevron--up': isNoticeExpanded }"
              aria-hidden="true"
            ></span>
          </button>
        </div>
      </section>
      <!--    카테고리 영역    -->
      <section class="section border-bottom">
        <!-- 각 카테고리 클릭 시 해당 카테고리 페이지로 이동 좌/우 스와이프 가능
         윗줄 5개 채우면 아래줄 생성 총12개 채울시 옆으로 슬라이드-->
        <div class="category-wrap">
          <Swiper
            v-memo="[categoryMemoKey]"
            :scrollbar="{
              el: '.swiper-scrollbar'
            }"
            :modules="modules"
            class="swiper mySwiper"
          >
            <SwiperSlide v-for="(chunk, index) in chunkedCategories" :key="index">
              <ul class="category-ul">
                <li
                  v-for="(item, cIndex) in chunk"
                  :key="item.id"
                  class="category-item"
                  @click="routeTo(`search`, item.productCategoryNo)"
                >
                  <div class="thumb">
                    <img
                      :src="
                        !item.productCategoryNo
                          ? allCategoryImage
                          : !item.file?.storedFileName
                          ? emptyCategoryImage
                          : getImagePath(item.file?.storedFileName, '480')
                      "
                      :loading="index === 0 && cIndex < 6 ? 'eager' : 'lazy'"
                      decoding="async"
                    />
                  </div>
                  <p>{{ Util.translator(item, 'category') }}</p>
                </li>
              </ul>
            </SwiperSlide>
            <div class="swiper-scrollbar"></div>
          </Swiper>
        </div>
      </section>
      <section class="section border-bottom" v-for="(item, index) in visibleProducts" :key="index">
        <div class="title-wrap" @click="routeTo(`search`, item.productCategoryNo)">
          <h3 class="title">{{ locale === 'ko' ? item.categoryKr : item.categoryVn }}</h3>
          <i class="i-right"></i>
        </div>
        <ul class="product-wrap grid-line01">
          <!--grid-line01 가로로 스와이프, 한 줄-->
          <product-item :data="item.products" :locale="locale" :is-page="false" />
        </ul>
      </section>
      <section class="section border-bottom" v-if="isMainProductsLoaded && categoryProducts.length > 0">
        <div class="title-wrap">
          <h3 class="title">{{ $t('store.info.recent_info') }}</h3>
        </div>
        <ul class="product-wrap grid-line03">
          <!--grid-line03 가로 세 줄-->
          <product-item :data="categoryProducts" :locale="locale" :is-page="false"></product-item>
        </ul>
      </section>
    </div>
  </div>

  <div class="btn-to-top" style="bottom: 12.2rem" @click="goToTop" v-show="isArrowShow">
    <button></button>
  </div>
  <div class="btm-order-btn" :class="{ disabled: !orderable }">
    <p v-if="!orderable">{{ $t('store.segmented_control.product.cant_delivery_msg') }}</p>
    <p v-if="orderable">
      {{ $t('store.info.expected_delivery_fee') }}:{{
        isNegoDeliveryFee ? $t('cart.nego_delivery_fee') : toVn(expectedDeliveryFee)
      }}
    </p>
    <button class="btn yd-cta yd-cta--primary" v-if="orderable && cartCount > 0" @click="fnCart">
      <span class="badge">{{ cartCount > 99 ? '99+' : cartCount }}</span
      >{{ isNegoDeliveryFee ? toVn(totalPrice - totalDiscountPrice) : toVn(totalPrice - totalDiscountPrice) }}
    </button>
  </div>
</template>

<script setup>
import { getImagePath } from '@/common/constants/ConstCode';
import Util from '@/common/utils/Util';
import { onBeforeRouteLeave, useRoute, useRouter } from 'vue-router';
import { computed, nextTick, onActivated, onBeforeMount, onMounted, onUnmounted, ref, watch, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { dot, toVn } from '@/common/utils/Currency';
import { extractPhone, formatPhone } from '@/common/utils/PhoneNumber';
import { modalList, show } from '@/common/utils/ControlModal';
import { useI18n } from 'vue-i18n';
import { cloneDeep, debounce } from 'lodash';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Scrollbar } from 'swiper';
import 'swiper/swiper-bundle.css';
import ProductItem from '@/components/views/store/ProductItem.vue';
import {
  addScrollListener,
  detachScrollListener,
  goToTop,
  initScrollAction,
  isArrowShow
} from '@/views/store/product/ProductScrollAction';
import allCategoryImage from '@/assets/static/images/sample/all-category.png';
import emptyCategoryImage from '@/assets/static/images/sample/image-06-06.png';
import { hasDisplayableProducts } from '@/views/store/product/productAvailability';

const $store = useStore();
const { path } = useRoute();
const { replace, push } = useRouter();
const { params } = useRoute();
const { nativeTel, translator, getDistance } = Util;
const { t } = useI18n();
const route = useRoute();

const modules = [Scrollbar];
const products = ref([]);
const allProducts = ref([]);
const categoryProducts = ref([]);
const productScrollTop = ref(0);
const visibleProducts = computed(() => (products.value ?? []).filter(hasDisplayableProducts));
const visibleAllProducts = computed(() => (allProducts.value ?? []).filter(hasDisplayableProducts));

const getProductScrollTarget = () => document.getElementById('product-wrapper');

const saveProductScrollTop = () => {
  const scrollTarget = getProductScrollTarget();
  if (!scrollTarget) return;
  productScrollTop.value = scrollTarget.scrollTop;
};

const applyProductScrollTop = () => {
  const scrollTarget = getProductScrollTarget();
  if (!scrollTarget) return;
  scrollTarget.scrollTop = productScrollTop.value;
};

const restoreProductScrollTop = async () => {
  await nextTick();
  applyProductScrollTop();
  requestAnimationFrame(applyProductScrollTop);
};

const chunkedCategories = computed(() => {
  const base = visibleAllProducts.value;

  // "전체보기" 아이템을 products 배열의 첫 번째에 추가
  const withAll = [
    {
      id: null,
      storeCategoryNo: null,
      categoryKr: '전체보기',
      categoryVn: 'Tất cả',
      file: null
    },
    ...base
  ];

  return chunkArray(withAll, 12);
});
const categoryMemoKey = computed(() => {
  const base = visibleAllProducts.value;
  return base.map((item) => item.productCategoryNo ?? item.id ?? '').join(',');
});

const syncStoreTitle = () => {
  const storeName = translator(storeInfo.value, 'name');
  if (!storeName) return;
  $store.commit('layout/setTitleName', { titleName: storeName });
};

const recentProducts = computed(() => {
  const allCategoryGroups = allProducts.value || [];
  const allCategoryProducts = allCategoryGroups.flatMap((group) => group.products || []);

  const newProducts = allCategoryProducts
    // .filter((item) => item.isNew)
    // .sort(() => Math.random() - 0.5)
    .sort((a, b) => b.productNo - a.productNo)
    .slice(0, 9);
  return [
    {
      categoryNo: null,
      products: newProducts
    }
  ];
});

const isNegoDeliveryFee = computed(() => {
  return storeInfo?.value.isNegoDeliveryFee ?? false;
});

const orderable = computed(() => {
  return (
    storeInfo?.value.isShow &&
    storeInfo?.value.isActive &&
    storeInfo?.value.isDeliverable &&
    storeInfo?.value.businessStatus === 'OPEN' &&
    storeInfo?.value.isWork
  );
});

function chunkArray(array, size) {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}

onActivated(() => {
  syncStoreTitle();
  void restoreProductScrollTop();
  scheduleNoticeMeasurement();
});

onMounted(() => {
  initScrollAction();
  addScrollListener();
  window.addEventListener('resize', scheduleNoticeMeasurement, { passive: true });
});

onBeforeRouteLeave(() => {
  saveProductScrollTop();
});

onBeforeMount(async () => {
  $store.commit('layout/setIsForceLoading', { isForceLoading: true });
  $store.commit('store/setStoreCategoryNo', null);
  $store.commit('store/setProducts');
  $store.commit('store/setSearchCategoryProduct', {});
  products.value = [];
  allProducts.value = [];
  categoryProducts.value = [];
  isMainProductsLoaded.value = false;

  const { userNo } = $store.getters['user/getUserData'];
  const parsedStoreNo = Number(params.storeNo);

  try {
    await $store.dispatch('store/getStoreDetail', {
      storeNo: parsedStoreNo,
      userNo
    });

    const { isFav } = storeInfo.value;

    isFavStore.value = isFav;

    const store = cloneDeep($store.getters['store/getStoreInfo']);
    $store.commit('recent/setStore', store);
    $store.commit('layout/setTitleName', { titleName: translator(storeInfo.value, 'name') });

    const lastIndex = path.lastIndexOf('/');
    thisPage.value = path.substring(lastIndex + 1);
    $store.commit('store/setCategoryProductPageInfo', { page: 1, totalPage: 2 });

    // const favoritePromise = $store.dispatch('favorite/getMyFavStores', { userNo });
    const allCategoriesPromise = $store.dispatch('store/FETCH_ALL_CATEGORIES', {
      ...parameter.value,
      storeNo: parsedStoreNo,
      isMain: null,
      isWithProduct: true
    });
    const mainCategoriesPromise = $store
      .dispatch('store/FETCH_CATEGORIES', {
        ...parameter.value,
        storeNo: parsedStoreNo,
        isMain: true,
        isWithProduct: true
      })
      .then(() => {
        isMainProductsLoaded.value = true;
      });
    // const recentProductsPromise = $store.dispatch('store/FETCH_SEARCH_CATEGORY_PRODUCTS', {
    //   storeNo: parsedStoreNo,
    //   productCategoryNo: 0,
    //   limit: 15
    // });

    await Promise.all([allCategoriesPromise, mainCategoriesPromise]);

    allProducts.value = cloneDeep($store.getters['store/getAllProducts']);
    products.value = cloneDeep($store.getters['store/getProducts']);

    await $store.dispatch('store/FETCH_SEARCH_CATEGORY_PRODUCTS', {
      storeNo: parsedStoreNo,
      productCategoryNo: 0,
      limit: 15,
      notLoading: true
    });
    categoryProducts.value = cloneDeep($store.getters['store/getCategoryProducts']);

    // isFavStore.value = (favStoreList ?? []).some((val) => val.storeNo === parsedStoreNo);
  } finally {
    $store.commit('layout/setIsForceLoading', { isForceLoading: false });
  }
});

const parameter = ref({
  categoryText: '',
  storeNo: -1,
  isMain: true
});

onUnmounted(() => {
  $store.commit('store/initStoreInfo');
  detachScrollListener();
  window.removeEventListener('resize', scheduleNoticeMeasurement);
  noticeResizeObserver?.disconnect();
  if (noticeMeasureFrame !== null && typeof window.cancelAnimationFrame === 'function') {
    window.cancelAnimationFrame(noticeMeasureFrame);
  }
});

const thisPage = ref('');
const isFavStore = ref(false);
const isMainProductsLoaded = ref(false);
const locale = computed(() => $store.getters['locale/getLocale']);
const storeInfo = computed(() => $store.getters['store/getStoreInfo']);
const userPosition = computed(() => $store.getters['user/getUserPosition']);
const userInfo = computed(() => $store.getters['user/getUserData']);

const noticeSection = ref(null);
const noticeContent = ref(null);
const isNoticeExpanded = ref(false);
const isNoticeOverflowing = ref(false);
const storeNotice = computed(() => {
  const noticeByLocale = {
    ko: storeInfo.value?.storeNoticeKr,
    vn: storeInfo.value?.storeNoticeVn,
    en: storeInfo.value?.storeNoticeEn
  };

  return noticeByLocale[locale.value] || Util.translator(storeInfo.value, 'storeNotice') || '';
});

const noticeMediaElementSelector =
  'img, picture, video, audio, iframe, embed, object, svg, canvas, math, hr, source, track';
const noticeIgnoredElementSelector = 'script, style, template, noscript';
const noticeTextBreakElementSelector =
  'address, article, aside, blockquote, dd, details, dialog, div, dl, dt, fieldset, ' +
  'figcaption, figure, footer, form, h1, h2, h3, h4, h5, h6, header, hgroup, li, main, ' +
  'nav, ol, option, p, pre, section, summary, table, tbody, tfoot, thead, tr, ul';

const normalizeNoticeText = (value) =>
  String(value ?? '')
    .replace(/\r\n?/g, '\n')
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    .replace(/[^\S\n]+/g, ' ')
    .replace(/ *\n */g, '\n')
    .trim();

const extractNoticeText = (node) => {
  if (node.nodeType === 3) {
    const value = node.nodeValue ?? '';
    return node.parentElement && ['PRE', 'TEXTAREA'].includes(node.parentElement.tagName)
      ? value
      : value.replace(/\s+/g, ' ');
  }
  if (node.nodeType !== 1) return '';
  if (node.tagName === 'BR') return '\n';

  let text = Array.from(node.childNodes).map(extractNoticeText).join('');
  if (node.tagName === 'TD' || node.tagName === 'TH') text += ' ';
  if (node.matches(noticeTextBreakElementSelector) && !/\n\s*$/.test(text)) text += '\n';
  return text;
};

const analyzeNotice = (html) => {
  const value = String(html ?? '');
  if (!value.trim()) return { containsMedia: false, text: '' };

  if (typeof document === 'undefined') {
    const visibleValue = value.replace(
      /<(script|style|template|noscript)\b[^>]*>[\s\S]*?<\/\1\s*>/gi,
      ''
    );
    const containsMedia =
      /<(?:img|picture|video|audio|iframe|embed|object|svg|canvas|math|hr|source|track)\b/i.test(
        visibleValue
      );
    const text = normalizeNoticeText(
      visibleValue
        .replace(
          /<(picture|video|audio|iframe|object|svg|canvas|math)\b[^>]*>[\s\S]*?<\/\1\s*>/gi,
          '\n'
        )
        .replace(/<(?:img|embed|hr|source|track)\b[^>]*\/?\s*>/gi, '\n')
        .replace(/<br\b[^>]*\/?\s*>/gi, '\n')
        .replace(/<\/[^>]+>/g, ' ')
        .replace(/<[^>]*>/g, '')
        .replace(/&(?:nbsp|#160|#xA0);/gi, ' ')
    );

    return { containsMedia, text };
  }

  const container = document.createElement('div');
  container.innerHTML = value;
  container.querySelectorAll(noticeIgnoredElementSelector).forEach((element) => element.remove());

  const containsMedia = container.querySelector(noticeMediaElementSelector) !== null;
  container.querySelectorAll(noticeMediaElementSelector).forEach((element) => element.remove());

  return { containsMedia, text: normalizeNoticeText(extractNoticeText(container)) };
};

const noticeAnalysis = computed(() => analyzeNotice(storeNotice.value));
const collapsedNoticeText = computed(() => noticeAnalysis.value.text);
const noticeContainsMedia = computed(() => noticeAnalysis.value.containsMedia);
const hasStoreNotice = computed(
  () => noticeContainsMedia.value || collapsedNoticeText.value.length > 0
);
const shouldShowNoticeToggle = computed(
  () => noticeContainsMedia.value || isNoticeOverflowing.value || isNoticeExpanded.value
);
const noticeSectionLabels = {
  ko: '상점 공지사항',
  vn: 'Thông báo cửa hàng',
  en: 'Store notice'
};
const noticeExpandLabels = {
  ko: '더보기',
  vn: 'Xem thêm',
  en: 'Show more'
};
const noticeCollapseLabels = {
  ko: '접기',
  vn: 'Thu gọn',
  en: 'Show less'
};
const noticeSectionLabel = computed(
  () => noticeSectionLabels[locale.value] ?? noticeSectionLabels.en
);
const noticeToggleLabel = computed(() => {
  const labels = isNoticeExpanded.value ? noticeCollapseLabels : noticeExpandLabels;
  return labels[locale.value] ?? labels.en;
});

let noticeResizeObserver = null;
let noticeMeasureFrame = null;

const measureNoticeOverflow = () => {
  const element = noticeContent.value;
  if (!hasStoreNotice.value) {
    isNoticeOverflowing.value = false;
    isNoticeExpanded.value = false;
    return;
  }
  if (!element || isNoticeExpanded.value) return;

  element.classList.add('store-main-notice__content--measuring');
  element.classList.remove('store-main-notice__content--collapsed');
  const fullHeight = element.getBoundingClientRect().height;

  element.classList.remove('store-main-notice__content--measuring');
  element.classList.add('store-main-notice__content--collapsed');
  const collapsedHeight = element.getBoundingClientRect().height;

  isNoticeOverflowing.value = fullHeight > collapsedHeight + 1;
};

const scheduleNoticeMeasurement = () => {
  if (typeof window === 'undefined') return;

  if (noticeMeasureFrame !== null && typeof window.cancelAnimationFrame === 'function') {
    window.cancelAnimationFrame(noticeMeasureFrame);
  }

  const measureAfterRender = () => {
    noticeMeasureFrame = null;
    void nextTick(measureNoticeOverflow);
  };

  if (typeof window.requestAnimationFrame === 'function') {
    noticeMeasureFrame = window.requestAnimationFrame(measureAfterRender);
  } else {
    void nextTick(measureNoticeOverflow);
  }
};

const scrollNoticeSectionToTop = () => {
  const scrollTarget = getProductScrollTarget();
  const section = noticeSection.value;
  if (!scrollTarget || !section) return;

  const scrollTargetRect = scrollTarget.getBoundingClientRect();
  const noticeSectionRect = section.getBoundingClientRect();
  const targetScrollTop =
    scrollTarget.scrollTop + noticeSectionRect.top - scrollTargetRect.top;

  scrollTarget.scrollTo({
    top: Math.max(0, targetScrollTop),
    left: 0,
    behavior: 'smooth'
  });
};

const toggleNotice = async () => {
  if (!isNoticeExpanded.value) {
    isNoticeExpanded.value = true;
    await nextTick();
    scrollNoticeSectionToTop();
    return;
  }

  isNoticeExpanded.value = false;
  await nextTick();
  scheduleNoticeMeasurement();
  getProductScrollTarget()?.scrollTo({ top: 0, left: 0, behavior: 'auto' });
};

watch(
  [locale, storeNotice],
  () => {
    isNoticeExpanded.value = false;
    isNoticeOverflowing.value = false;
    scheduleNoticeMeasurement();
  },
  { immediate: true, flush: 'post' }
);

watch(
  noticeContent,
  (element) => {
    noticeResizeObserver?.disconnect();
    noticeResizeObserver = null;

    if (element && typeof ResizeObserver !== 'undefined') {
      noticeResizeObserver = new ResizeObserver(scheduleNoticeMeasurement);
      noticeResizeObserver.observe(element);
    }

    scheduleNoticeMeasurement();
  },
  { flush: 'post' }
);

const cartCount = computed(() => {
  const cartWrapper = $store.getters['cart/getCart'];
  const count = (cartWrapper.cart ?? []).reduce((prev, next) => {
    return prev + (next?.stock ?? 0);
  }, 0);
  if (Number(params.storeNo) === Number(cartWrapper.storeNo)) {
    return count;
    // return count > 99 ? '99+' : count;
  } else {
    return 0;
  }
});

const accumulateType = computed(() => {
  return $store.getters['constant/getConstant']['ACCUMULATE_TYPE'];
});

const star = computed(() => {
  const { starRate } = storeInfo.value;

  if (!starRate) return 0.0;
  else return starRate.toFixed(1);
});

const calcStar = (rate) => {
  if (Number.isNaN(Number(rate))) return null;
  let value = Math.round(rate);
  let result = ['', '', '', '', ''];
  result = result.map(() => {
    let result = '';
    if (value > 0) result = 'i-star-32';
    else result = 'i-star-32-none';
    value -= 1;
    return result;
  });
  return result;
};

const chat = async () => {
  const { userNo, name } = $store.getters['user/getUserData'];
  const accessToken = $store.getters['user/getAccessToken'];
  if (!userNo || !accessToken) {
    show(modalList.Alert, {
      title: '',
      text: t('modal.need_to_sign_in.text'),
      confirmText: t('modal.need_to_sign_in.confirmText'),
      confirmCallback: () => push('/sign/in')
    });

    return;
  }
  if (userNo === storeInfo.value.userNo) {
    push(`/chat/inquiry`);
    // show(modalList.Alert, {
    //   title: '',
    //   text: t('chat.modal.self_not_allow.description'),
    //   confirmText: t('chat.modal.self_not_allow.ok')
    // });
    return;
  }
  $store.commit('chat/setName', name);
  $store.commit('chat/setHeader', { userNo, accessToken });
  const { storeNo } = params;
  const roomNo = await $store.dispatch('chat/CREATE_CHATROOM', {
    roomType: `INQUIRY`,
    userNo,
    storeNo: Number(storeNo)
  });
  push(`/room/${roomNo}/INQUIRY`);
  $store.dispatch('store/SAVE_ACCUMULATE', {
    storeNo,
    type: accumulateType.value['ACCUMULATE_INQUIRY'].key
  });
};
const call = () => {
  const { phone } = storeInfo.value;
  if (!phone) return;

  nativeTel(extractPhone(phone));
  const { storeNo } = params;
  $store.dispatch('store/SAVE_ACCUMULATE', {
    storeNo,
    type: accumulateType.value['ACCUMULATE_PHONE'].key
  });
};
const like = debounce(async () => {
  const { userNo } = $store.getters['user/getUserData'];
  if (!userNo) {
    show(modalList.Alert, {
      title: '',
      text: t('modal.need_to_sign_in.text'),
      confirmText: t('modal.need_to_sign_in.confirmText'),
      confirmCallback: () => push('/sign/in')
    });

    return;
  }
  const wasFavorite = isFavStore.value;
  const success = await $store.dispatch(
    wasFavorite ? 'favorite/hate_store' : 'favorite/like_store',
    {
      userNo: userInfo.value.userNo,
      storeNo: params.storeNo
    }
  );

  if (success) isFavStore.value = !wasFavorite;
}, 300);

const routeTo = (to, storeCategoryNo, nested = true) => {
  $store.commit('store/setSearchCategoryProduct', {});
  $store.commit('store/setStoreCategoryNo', storeCategoryNo);
  if (!nested) return push(to);
  else {
    // const scrollTop = document.getElementById('scrollable').scrollTop;
    // $store.commit('layout/setScrollTop', scrollTop);

    const lastIndex = path.lastIndexOf('/');
    const base = path.substring(0, lastIndex);

    push(`${base}/${to}`);
    thisPage.value = to;
  }
};

const bill = ref({
  orderType: null,
  cart: []
});

const readyData = () => {
  bill.value.cart = [...$store.getters['payment/getCart']].sort((elem1, elem2) => elem1.productNo - elem2.productNo);
};

watchEffect(() => {
  readyData();
});

const storeInformation = computed(() => $store.getters['payment/getStoreInfo']);

const totalPrice = computed(() => {
  // const { cart } = bill.value;
  const { cart } = $store.getters['cart/getCart'];
  return cart.reduce((prev, next) => {
    const optionsPrice = (next?.optionGroups ?? [])
      .flatMap((elem) => elem.options)
      .reduce((prev, next) => {
        return prev + next?.additionalFee ?? 0;
      }, 0);
    //
    return prev + (next?.stock ?? 0) * ((next?.price ?? 0) + optionsPrice);
  }, 0);
});

const totalDiscountPrice = computed(() => {
  const { cart } = $store.getters['cart/getCart'];
  const { orderType } = bill.value;
  const { store } = storeInformation.value;
  const { discountWhenPack } = store ?? { discountWhenPack: 0 };
  // let discount = cart.reduce((prev, next) => {
  //   return prev + (next?.stock ?? 0) * Number(((next?.price ?? 0) * (next?.discountRate ?? 0)).toFixed(0));
  // }, 0);
  let discount = 0;
  if (orderType === 'TYPE_PACKING') discount += discountWhenPack;

  return discount;
});
const expectedDeliveryFee = computed(() => {
  // if (bill.value.orderType !== 'TYPE_DELIVERY') return 0;

  const { store } = storeInformation.value;
  const {
    baseDeliveryFee,
    baseDeliveryFeeLimit,
    increaseDeliveryFeePer,
    additionalDeliveryFee,
    maximumDeliveryFee,
    noDeliveryFeeWhen,
    latitude,
    longitude,
    isNegoDeliveryFee
  } = storeInfo.value;

  const user = $store.getters['user/getUserPosition'];

  if (totalPrice.value - totalDiscountPrice.value >= noDeliveryFeeWhen) return t('store.info.free_delivery_fee');

  let fee = baseDeliveryFee;

  const distance = Math.round(getDistance(user.latitude, user.longitude, latitude, longitude).toFixed(1));
  if (distance <= baseDeliveryFeeLimit) return fee;

  let calc = distance - baseDeliveryFeeLimit;
  while (increaseDeliveryFeePer > 0 && calc > 0) {
    calc -= increaseDeliveryFeePer;
    fee += additionalDeliveryFee;
  }

  if (fee >= maximumDeliveryFee) return maximumDeliveryFee;
  if (isNegoDeliveryFee) return 0;
  return fee;
});

const fnCart = async () => {
  if (/^\/shop\/\d+\/product\/\d+$/.test(route.fullPath)) {
    await replace('/cart');
  } else {
    await push('/cart');
  }
};
</script>
<style scoped lang="scss">
#product-wrapper {
  box-sizing: border-box;
  padding: 1rem 1rem;
  scroll-padding-bottom: calc(6.5rem + 1.2rem + env(safe-area-inset-bottom));

  > .store-info-wrap {
    margin-bottom: 0;
  }
}

.store-info-wrap {
  .top-store-info,
  .section .title-wrap,
  .product-wrap.grid-line01,
  .product-wrap.grid-line03 {
    padding-right: 1rem;
    padding-left: 1rem;
  }
}

.store-main-notice {
  padding: 0.6rem 1rem;

  &__inner {
    position: relative;
    padding: 0.7rem 0.9rem;
    border: 1px solid #d8f3fa;
    border-radius: 1.4rem;
    background: #eaf9fd;
  }

  &__content {
    margin-top: 0;
    color: #555;
    font-size: 1.4rem;
    line-height: 1.5;
    overflow-wrap: anywhere;
    word-break: break-word;

    :deep(p) {
      margin: 0 0 0.4rem;
    }

    :deep(p:last-child) {
      margin-bottom: 0;
    }

    :deep(img) {
      display: block;
      max-width: 100%;
      height: auto;
      margin: 0.5rem 0;
    }

    &--collapsed {
      display: -webkit-box;
      max-height: 3em;
      overflow: hidden;
      white-space: pre-line;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }

    &--measuring {
      display: block;
      max-height: none;
      overflow: visible;
      white-space: pre-line;
      -webkit-line-clamp: unset;
    }
  }

  &__toggle {
    display: block;
    width: auto;
    max-width: 100%;
    margin: 0.4rem 0 0 auto;
    padding: 0.2rem 0.3rem;
    border: 0;
    color: #4f6b75;
    font: inherit;
    font-size: 1.4rem;
    font-weight: 600;
    line-height: 1.4;
    background: transparent;
    cursor: pointer;
    white-space: nowrap;
  }

  &__toggle-chevron {
    display: inline-block;
    width: 0.55rem;
    height: 0.55rem;
    margin-left: 0.45rem;
    border-right: 0.14rem solid currentColor;
    border-bottom: 0.14rem solid currentColor;
    vertical-align: 0.2rem;
    transform: rotate(45deg);

    &--up {
      vertical-align: -0.1rem;
      transform: rotate(225deg);
    }
  }

  &--collapsed {
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;

    .store-main-notice__inner {
      display: grid;
      grid-template-columns: 6rem minmax(0, 1fr) auto;
      grid-template-areas: 'icon content toggle';
      column-gap: 0.55rem;
      align-items: center;
      padding: 0.3rem;
      border-color: #DCEFF7;
      background: #EEF8FC;
    }

    .store-main-notice__icon {
      display: block;
      grid-area: icon;
      align-self: center;
      justify-self: center;
      width: 5rem;
      height: 5rem;
      object-fit: contain;
    }

    .store-main-notice__content,
    .store-main-notice__toggle {
      font-size: 1.3rem;
      line-height: 1.4;
    }

    .store-main-notice__content {
      grid-area: content;
      min-width: 0;
      margin-top: 0;
    }

    .store-main-notice__toggle {
      grid-area: toggle;
      align-self: center;
      justify-self: end;
      width: auto;
      margin-top: 0;
      padding: 0.1rem 0.2rem;
    }

    .store-main-notice__toggle-chevron {
      margin-right: 0.5rem;
    }
  }
}

.category-wrap .swiper .swiper-scrollbar {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 3rem;
  height: 0.4rem;
  border-radius: 5rem;
  background: rgba(0, 0, 0, 0.1);
  z-index: 50;
}

#product-wrapper {
  background: #ffffff;
  color: #334155;
  font-size: 1.4rem;
}

#product-wrapper > .store-info-wrap {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

#product-wrapper .store-info-wrap > .section {
  overflow: hidden;
  border: 1px solid #e5eaed;
  border-radius: 1.1rem;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);
}

#product-wrapper .store-info-wrap > .section.border-bottom {
  border-bottom: 1px solid #e5eaed;
}

#product-wrapper .store-info-wrap > .section .product-wrap {
  border-bottom: 0;
}

#product-wrapper .store-info-wrap .top-store-info {
  padding: 1rem;
}

#product-wrapper .store-info-detail-wrap {
  gap: 1rem;
}

#product-wrapper .store-info-detail-wrap ul li,
#product-wrapper .store-info-detail-wrap .content .review-wrap .review {
  font-size: 1.4rem;
}

#product-wrapper .store-info-detail-wrap ul li .title {
  color: #64748b;
}

#product-wrapper .store-info-detail-wrap .content .btn-wrap .btn {
  border-color: #e5eaed;
  border-radius: 0.9rem;
  background: #ffffff;
}

#product-wrapper .store-main-notice {
  padding: 1rem;
}

#product-wrapper .store-main-notice--collapsed {
  padding: 0.6rem;
}

#product-wrapper .store-main-notice__inner {
  border-radius: 1rem;
}

#product-wrapper .category-wrap {
  padding: 1rem;
}

#product-wrapper .category-item .thumb {
  overflow: hidden;
  border: 1px solid #e5eaed;
  background: #f8fafc;
}

#product-wrapper .category-item p {
  color: #475569;
  font-size: 1.4rem;
  line-height: 1.3;
}

#product-wrapper .store-info-wrap .section .title-wrap {
  padding: 1rem;
  border-bottom: 1px solid #e5eaed;
  background: #ffffff;
}

#product-wrapper .store-info-wrap .section .title-wrap .title {
  color: #1e293b;
  font-size: 1.5rem;
  font-weight: 700;
}

#product-wrapper .product-wrap.grid-line01,
#product-wrapper .product-wrap.grid-line03 {
  gap: 1rem;
  padding: 1rem;
}

.btm-order-btn {
  border-top: 1px solid #e5eaed;
  background: #ffffff;
  box-shadow: 0 -2px 6px rgba(15, 23, 42, 0.05);
}

.btm-order-btn.disabled {
  background: #f8fafc;
}
</style>
/* *Created on 2023-08-28 *ProjectName user */
<script>
export default {
  name: 'STORE_DETAIL'
};
</script>
